import React from "react";
import playStoreBadge from "../assets/img/playstore.png";
import appStoreBadge from "../assets/img/a2.svg";

// Shows only the stores an app is on; "mac" uses the App Store badge.
const Buttons = ({ links }) => {
  const appStore = links.ios || links.mac;
  if (!links.android && !appStore) {
    return <p style={{ fontWeight: "bold" }}>Coming soon to the Mac App Store</p>;
  }

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {links.android && (
        <a href={links.android} target="_blank" rel="noopener noreferrer">
          <img
            src={playStoreBadge}
            alt={"Google Play"}
            width={"150px"}
          />
        </a>
      )}
      {appStore && (
        <a href={appStore} target="_blank" rel="noopener noreferrer">
          <img
            src={appStoreBadge}
            alt={"App Store"}
            width={"150px"}
            height={"40px"}
          />
        </a>
      )}
    </div>
  );
};

export default Buttons;
